import { h } from 'preact';
import { useRef, useEffect } from 'preact/hooks';
import { createPortal } from 'preact/compat';
import CloseIcon from './closeIcon';
const Confirmation = ({ open , title , subtitle , content , confirmText ='Confirm' , cancelText ='Cancel' , onConfirm , onCancel , className , disabled =false , loadingText  })=>{
    const closeRef = useRef(null);
    useEffect(()=>{
        if (open && closeRef.current) closeRef.current.focus();
    }, [
        open
    ]);
    if (!open) return null;
    const titleId = 'confirmation-title';
    const descId = 'confirmation-description';
    const stop = (e)=>{
        e.stopPropagation();
        try {
            const evt = e;
            if (evt.preventDefault) evt.preventDefault();
        } catch (err) {
        // ignore
        }
    };
    const dialog = h('div', {
        className: 'confirmation__overlay',
        onClick: disabled ? undefined : onCancel,
        'aria-hidden': 'false'
    }, h('div', {
        role: 'dialog',
        'aria-modal': 'true',
        'aria-labelledby': titleId,
        'aria-describedby': descId,
        className: `confirmation ${className || ''}`.trim(),
        onClick: stop,
        onMouseDown: stop
    }, h('button', {
        type: 'button',
        className: 'confirmation__close',
        onClick: disabled ? undefined : onCancel,
        disabled,
        ref: closeRef,
        'aria-label': 'Close'
    }, h(CloseIcon, {
        className: 'confirmation__closeIcon',
        width: 20,
        height: 20
    })), h('div', {
        id: titleId,
        className: 'confirmation__title'
    }, title), h('div', {
        id: descId,
        className: 'confirmation__subtitle'
    }, subtitle), h('div', {
        id: descId,
        className: 'confirmation__content'
    }, content), h('div', {
        className: 'confirmation__actions'
    }, h('button', {
        type: 'button',
        onClick: disabled ? undefined : onCancel,
        disabled,
        className: 'o-button o-button--hollow confirmation__cancel',
        tabIndex: 0
    }, cancelText), h('button', {
        type: 'button',
        onClick: disabled ? undefined : onConfirm,
        disabled,
        className: 'o-button confirmation__accept',
        tabIndex: 0
    }, disabled && loadingText ? loadingText : confirmText))));
    if (typeof document !== 'undefined' && document.body) {
        return createPortal(dialog, document.body);
    }
    return dialog;
};
export default Confirmation;
